import apiClient from './client';

export const watchlistApi = {
  /**
   * Get all watchlists
   */
  getAllWatchlists: async () => {
    const response = await apiClient.get('/api/watchlist');
    return response.data;
  },

  /**
   * Get watchlist by ID
   */
  getWatchlistById: async (id) => {
    const response = await apiClient.get(`/api/watchlist/${id}`);
    return response.data;
  },

  /**
   * Get watchlist by name
   */
  getWatchlistByName: async (name) => {
    const response = await apiClient.get(`/api/watchlist/name/${encodeURIComponent(name)}`);
    return response.data;
  },

  /**
   * Create a new watchlist
   */
  createWatchlist: async (name, symbols = []) => {
    const response = await apiClient.post('/api/watchlist', { name, symbols });
    return response.data;
  },

  /**
   * Update watchlist by ID
   */
  updateWatchlist: async (id, name, symbols) => {
    const response = await apiClient.put(`/api/watchlist/${id}`, { name, symbols });
    return response.data;
  },

  /**
   * Delete watchlist by ID
   */
  deleteWatchlist: async (id) => {
    const response = await apiClient.delete(`/api/watchlist/${id}`);
    return response.data;
  },

  /**
   * Add symbol to watchlist
   */
  addSymbol: async (watchlistId, symbol) => {
    const response = await apiClient.post(`/api/watchlist/${watchlistId}/symbols`, { symbol });
    return response.data;
  },

  /**
   * Remove symbol from watchlist
   */
  removeSymbol: async (watchlistId, symbol) => {
    const response = await apiClient.delete(`/api/watchlist/${watchlistId}/symbols/${symbol}`);
    return response.data;
  },

  /**
   * Get market data for watchlist by ID
   */
  getWatchlistMarketData: async (watchlistId) => {
    const response = await apiClient.get(`/api/watchlist/${watchlistId}/market-data`);
    return response.data;
  },

  // Legacy methods for backward compatibility
  getQuotes: async (symbols) => {
    const response = await apiClient.post('/api/watchlist/quotes', { symbols });
    return response.data;
  },

  getMarketData: async (symbols) => {
    const response = await apiClient.post('/api/watchlist/market-data', { symbols });
    return response.data;
  },
};
